import { render, staticRenderFns } from "./setwithdrawal.vue?vue&type=template&id=74fd18c1&scoped=true"
import script from "./setwithdrawal.vue?vue&type=script&lang=js"
export * from "./setwithdrawal.vue?vue&type=script&lang=js"
import style0 from "./setwithdrawal.vue?vue&type=style&index=0&id=74fd18c1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74fd18c1",
  null
  
)

export default component.exports